module.exports = require("./fr-MG.js");